//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import './curalate.module';
import './initialization/angular/angular-react-components-init';
import './initialization/isotope/isotope-jquery-bridget';
import './logger/logger-angular-init';
import './routing';
import './shared/components/atomic-angular-components-init';

import './dashboard/dashboard.app';
